import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage } from 'hook/services'
import { useAgencyInfo } from 'context/agency'
import { Button, FormControl, MenuItem, Select, Stack } from '@mui/material'
import Multiselect from './components/Multiselect'


import { useNavigate, useParams } from 'react-router-dom'
	
const CreateModal = ({ handleRefresh, category }) => {
  const uploadImage = useUploadImage()

  const [agency] = useAgencyInfo()
  const AppService = useAppServices()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
  const {page_id} = useParams()
  // console.log(svgIcon, "svgIcon")
  const handleModal = () => {
    setOpenAddProduct(true)
  }
  console.log(page_id, "page_id1111")

  const closeAddProduct = () => {
    setOpenAddProduct(false)
  }


  const handleCsvUpload = async (e) => {
    e.preventDefault();
    const fileInput = e.target;
    const file = fileInput.files[0];

    if (!file) {
      alert("Please select a file");
      return;
    }

    const formData = new FormData();
    formData.append("csvFile", file);
    formData.append("agency_id", agency._id);

    setProcessing(true);
    const response = await AppService.award_ranking.uploadCsv({ payload: formData });

    if (response) {
      fileInput.value = ""; // Reset file input
      alert("CSV uploaded successfully!"); // Show success alert
      handleRefresh();
    }

    setProcessing(false);
  };


  const handleSubmit = async (e) => {

    e.preventDefault();
    setProcessing(true);
    let image_response;
    if(e.target?.image?.files?.[0]) {
    image_response = await uploadImage({
      file: e.target?.image?.files?.[0],
      desiredPath: `app/logo/image`,
    })
  }


    const payload = {
      name: e.target.name.value,
      rank: e.target.rank.value,
      points: e.target.points.value,
      // category: e.target.category.value,
      category: page_id,
      priority: e.target.priority.value,
      image: image_response?.response.data?image_response?.response.data:"",
    };

    console.log(payload, "payload");



    const { response } = await AppService.award_ranking.create({ payload });

    if (response) {
      setProcessing(false);
      closeAddProduct();
      handleRefresh();
    }
  };


  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>

        <MDButton color="white" variant="contained" onClick={handleModal}>
          Create
        </MDButton>
        <input
          type="file"
          accept=".csv"
          onChange={handleCsvUpload}
          style={{ display: 'none' }}
          id="csv-upload"
        />
        <label htmlFor="csv-upload">
          <MDButton color="white" variant="contained" component="span" disabled={processing}>
            Upload CSV
          </MDButton>
        </label>
      </div>
      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style} >
            <MDTypography variant="h5" mb={2}>
              Create Awards Ranking
            </MDTypography>
            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">priority</MDTypography>
              <MDInput label="priority" name="priority" fullWidth required />
            </MDBox>

{/* 
            <MDBox mb={2}>
              <MDTypography variant="button">Category</MDTypography>
              <MDInput
                select
                name="category"
                fullWidth
                required
                SelectProps={{ native: true }}
              >
                <option value="">Select a category</option>
                {category.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.name}
                  </option>
                ))}
              </MDInput>
            </MDBox> */}
            <MDBox mb={2}>
              <MDTypography variant="button">Type</MDTypography>
              <FormControl fullWidth>
                <Select name="rank" defaultValue="">
                  <MenuItem value="agency">Agency</MenuItem>
                  <MenuItem value="location">Location</MenuItem>
                  <MenuItem value="user">User</MenuItem>
                </Select>
              </FormControl>
            </MDBox>





            <MDBox mb={2}>
              <MDTypography variant="button">Point Required</MDTypography>
              <MDInput label="Point Required" name="points" fullWidth required />
            </MDBox>

            <Stack direction="row" alignItems="center" spacing={2}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                Upload Image +
                <input hidden name="image" type="file" />
              </Button>
            </Stack>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeAddProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default CreateModal
